export default {
    visitorCreate: 'สร้างผู้เยี่ยมเยือน',
    visitorEdit: 'แก้ไขผู้เยี่ยมเยือน',
    createNewVisitor: 'สร้างผู้เยี่ยมเยือน',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    profile: 'ข้อมูล',
    citizenIdPassportId: 'บัตรประชาชน / หนังสือเดินทาง',
    name: 'ชื่อ',
    enterVisitorName: 'ระบุชื่อผู้เยี่ยมเยือน',
    surname: 'นามสกุล',
    gender: 'เพศ',
    male: 'ชาย',
    female: 'หญิง',
    visitAt: 'เยี่ยมที่สำนักงาน',
    selectBureau: '- เลือกสำนักงาน -',
    emailAddress: 'อีเมล',
    enterEmailAddress: 'ระบุอีเมล',
    phoneNumber: 'เบอร์โทรศัพท์',
    operator: 'บุคคลที่มาเข้าพบ',
    operatorDetial: 'ระบุชื่อพนักงานที่ดูแลเพื่อส่งการแจ้งเตือน (ผ่าน Line) เมื่อผู้เยี่ยมเยือนมาถึงสำนักงาน',
    selectPermission: 'ค้นหารหัสพนักงาน',
    selectEmployeeName: 'ค้นหาชื่อพนักงาน',
    uploadIdCard: 'อัปโหลดบัตรประชาชน',
    pngMaxSizeMb: 'หมายเหตุ: JPG หรือ PNG ขนาดสูงสุด 10 MB',
    accessInformation: 'ข้อมูลการเข้าออก',
    startTime: 'เวลาเริ่ม',
    endTime: 'เวลาสิ้นสุด',
    setUpTimeRangeDay: 'ตั้งค่าเวลาต่อ 1 วัน',
    thisFieldIsRequired: 'กรุณากรอกข้อมูล',
    thisFieldIsExceeded255Characters: 'ข้อความเกิน 255 ตัวอักษร',
    emailIsRequired: 'กรุณากรอกอีเมล',
    emailIsExceeded255Characters: 'อีเมลเกิน 255 ตัวอักษร',
    invalidEMailFormat: 'รูปแบบอีเมลไม่ถูกต้อง',
    incorrectPhoneNumber: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    ImageSizeCanNot200Kb: 'ขนาดภาพต้องอยู่ระหว่าง 25KB และ 200KB',
    ImageSizeCanNot10Mb: 'Image size can not be less than 25KB or more than 10MB',
    StartInTimeMustBeLess: 'Start in time must be less than check in time.',
    EndInTimeMustBeMore: 'End in time must be more than last.'
}
